import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Provider } from "react-redux";
import { useSelector } from "react-redux";
import { ThemeProvider } from "styled-components";
import { ConfigProvider } from "antd";
import store from "./redux/store";
import Dashboard from "./routes/dashboard";
import ASM from "./routes/asm";
import Profile from "./routes/profile";
import Auth from "./routes/login";
import config from "./config/config";
import ProtectedRoute from "./components/utilities/protectedRoute";
import "./static/css/newStyle.css";
import GlobalStyle from "./styles/globalStyle";

const { theme } = config;

const AppRoutes = () => {
  const isLoggedIn = useSelector((state) => state.auth.login);

  const rtl = false;
  const topMenu = true;
  const darkMode = false;
  // const location = useLocation();

  // console.log('location',location)

  return (
    <ConfigProvider
      direction={rtl ? "rtl" : "ltr"}
      theme={{
        token: {
          fontFamily:
            'Geist, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        },
      }}
    >
      <ThemeProvider theme={{ ...theme, rtl, topMenu, darkMode }}>
        <GlobalStyle />
        <Routes>
          <Route
            path="/login/*"
            element={
              !isLoggedIn ? <Auth /> : <Navigate to="/dashboard" replace />
            }
          />

          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/asm/*" element={<ASM />} />
            <Route path="/profile/*" element={<Profile />} />
            {/* other protected routes */}
          </Route>

          <Route
            path="*"
            element={
              <Navigate to={isLoggedIn ? "/dashboard" : "/login"} replace />
            }
          />
        </Routes>
      </ThemeProvider>
    </ConfigProvider>
  );
};

const App = () => (
  <>
    <Provider store={store}>
      <Router basename={process.env.PUBLIC_URL}>
        <AppRoutes />
      </Router>
    </Provider>
  </>
);

export default App;
